var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_7434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.26 20C3.12 20 2.05 19.56 1.25 18.75C0.44 17.95 0 16.88 0 15.74V4.26C0 3.12 0.44 2.05 1.25 1.25C2.05 0.44 3.12 0 4.26 0H7.98C8.75 0 9.51 0.15 10.22 0.45C10.94 0.75 11.58 1.18 12.13 1.73L14.99 4.59C15.54 5.14 15.97 5.78 16.27 6.5C16.57 7.22 16.72 7.98 16.72 8.76V15.74C16.72 16.88 16.28 17.95 15.47 18.75C14.67 19.55 13.6 20 12.46 20H4.26ZM4.26 1.96C3.64 1.96 3.07 2.2 2.63 2.63C2.19 3.06 1.96 3.64 1.96 4.26V15.74C1.96 16.36 2.2 16.93 2.63 17.37C3.06 17.81 3.64 18.04 4.26 18.04H12.46C13.08 18.04 13.65 17.8 14.09 17.37C14.53 16.93 14.76 16.36 14.76 15.74V8.76C14.76 8.68 14.75 8.6 14.74 8.52H10.82C10.12 8.52 9.46 8.25 8.97 7.75C8.47 7.26 8.2 6.6 8.2 5.9V1.98C8.12 1.97 8.04 1.96 7.96 1.96H4.26ZM10.16 5.9C10.16 6.08 10.23 6.24 10.35 6.37C10.48 6.5 10.64 6.56 10.82 6.56H14.08C13.94 6.35 13.78 6.15 13.61 5.97L10.75 3.11C10.57 2.93 10.37 2.78 10.16 2.64V5.9ZM5.08 15.9C4.82 15.9 4.57 15.8 4.39 15.61C4.2 15.43 4.1 15.18 4.1 14.92C4.1 14.66 4.2 14.41 4.39 14.23C4.57 14.05 4.82 13.94 5.08 13.94H9.18C9.44 13.94 9.69 14.04 9.87 14.23C10.05 14.41 10.16 14.66 10.16 14.92C10.16 15.18 10.06 15.43 9.87 15.61C9.69 15.8 9.44 15.9 9.18 15.9H5.08ZM5.08 12.62C4.82 12.62 4.57 12.52 4.39 12.33C4.2 12.15 4.1 11.9 4.1 11.64C4.1 11.38 4.2 11.13 4.39 10.95C4.57 10.77 4.82 10.66 5.08 10.66H11.64C11.9 10.66 12.15 10.76 12.33 10.95C12.51 11.13 12.62 11.38 12.62 11.64C12.62 11.9 12.52 12.15 12.33 12.33C12.15 12.51 11.9 12.62 11.64 12.62H5.08Z",
    fill: "#334155"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_7434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.72,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/InvoiceIcon.b821b711ed504121268aa07048946cb0.svg";
export { ForwardRef as ReactComponent };